import chroma from 'chroma-js';

/*
 * WCAG Level AAA requires a contrast ratio of at least 7:1 for normal text and 4.5:1 for large text.
 * Large text is defined as 14 point (typically 18.66px) and bold or larger, or 18 point (typically 24px) or larger.
 * See https://webaim.org/resources/contrastchecker
 */
export function getTextColor(
  bgColor: string,
  fontSizePx: number = 16, // Ionic default font size
  isBold: boolean = false,
  shadePreference: 'dark' | 'light' = 'dark'
): string {
  // WCAG contrast target depends on the perceived "size" of the text.
  const targetContrast = fontSizePx && ((fontSizePx >= 18.66 && isBold) || fontSizePx >= 24) ? 4.5 : 7;

  const bg = chroma(bgColor);

  // Predefined gradients (5-step) from softer grey to pure black/white
  const blackShades = ['#333333', '#262626', '#1a1a1a', '#0d0d0d', '#000000'];
  const whiteShades = ['#cccccc', '#d9d9d9', '#e6e6e6', '#f2f2f2', '#ffffff'];

  const shades = shadePreference === 'dark' ? [...blackShades, ...whiteShades] : [...whiteShades, ...blackShades];

  // Return first shade that satisfies the target contrast
  for (const shade of shades) {
    const contrast = chroma.contrast(bg, shade);
    if (contrast >= targetContrast) {
      return shade;
    }
  }

  // No shade met the requirement – fall back to preferred pure base
  console.debug('No shade met the requirement', chroma.contrast(bg, 'black'), chroma.contrast(bg, 'white'));
  return chroma.contrast(bg, 'black') >= chroma.contrast(bg, 'white') ? 'black' : 'white';
}

export function getTextColorBW(bgColor: string) {
  const bg = chroma(bgColor);
  return chroma.contrast(bg, 'black') >= chroma.contrast(bg, 'white') ? 'black' : 'white';
}
